import React from 'react'

export function BarIcon() {
    return (
        <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0.0585938V3.63731H30V0.0585938H0ZM0 10.7947V14.3735H30V10.7947H0ZM0 21.5309V25.1096H30V21.5309H0Z" fill="white"/>
        </svg>
    )
}